import React, { Component } from "react";
import CloseSqaure from "../../../assets/images/auth/close-square.png";
import DocImage from "../../../assets/images/auth-home/doc-img.png";
import Arrowback from "../../../assets/images/auth/arrow-back.png";
import GoogleDrive from "../../../assets/images/auth-home/google-drive.png";
import DropBox from "../../../assets/images/auth-home/dropbox.png";
import DangerCircle from "../../../assets/images/auth-home/danger-circle.png";

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: "",
    };
  }

  handleFileChange = (e) => {
    // Update the state
    this.setState({ file: e.target });
    // for showing the image
    var input = e.target;
    var reader = new FileReader();
    reader.onload = () => {
      var dataURL = reader.result;
      var output = document.getElementById("image");
      output.src = dataURL;
    };
    reader.readAsDataURL(input.files[0]);
  };

  handlePublish = () => {
    this.props.getMediaData(this.state.file);
    this.props.closeModal();
  };

  render() {
    return (
      <React.Fragment>
        {this.props.width > 768 ? (
          <div className="d-flex justify-content-end">
            <img
              src={CloseSqaure}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={this.props.closeModal}
            />
          </div>
        ) : (
          <div className="row align-items-center">
            <div className="col-4">
              <img src={Arrowback} alt="" onClick={this.props.closeModal} />
            </div>
            <div
              className="col-8 px-0"
              style={{ color: "#181818", fontSize: 18, fontFamily: "Poppins" }}
            >
              Document
            </div>
          </div>
        )}
        <div style={{ marginTop: this.props.width > 992 ? 84 : 32 }}>
          <div className="d-flex justify-content-center pb-3">
            {this.state.file ? (
              <div
                style={{
                  height: this.props.width > 992 ? 200 : 172,
                  width: this.props.width > 992 ? 200 : 172,
                }}
              >
                <img
                  id="image"
                  alt=""
                  style={{ borderRadius: "50%" }}
                  className="w-100 h-100"
                />
              </div>
            ) : (
              <img src={DocImage} alt="" />
            )}
          </div>
          <p className="text-center th-auth-popup-media-txt1 mb-0">
            Drag and drop a dcument.
          </p>
          <p className="text-center th-auth-popup-media-txt2">or</p>
          <div className="d-flex justify-content-center mb-3">
            <label className="btn th-auth-popup-btn3 py-2">
              Browse
              <input
                type="file"
                style={{ display: "none" }}
                onChange={this.handleFileChange}
                // accept="application/pdf, .csv"
                accept="image/png, image/jpg, image/jpeg, video/mp4, video/webm, video/mkv, video/flv, video/avi"
                placeholder="Upload a photo"
                required
              />
            </label>
          </div>
        </div>
        {/* cloud upload part */}
        <p className="text-center th-auth-popup-media-txt2">
          Or upload from the cloud
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <div className="d-flex align-items-center mx-md-3 mx-2">
            <img src={GoogleDrive} alt="" />{" "}
            <span
              className="th-auth-popup-media-txt2"
              style={{ fontSize: 14, marginLeft: 6 }}
            >
              {" "}
              Google Drive{" "}
            </span>
          </div>
          <div className="d-flex align-items-center mx-md-3 mx-2">
            <img src={DropBox} alt="" />{" "}
            <span
              className="th-auth-popup-media-txt2"
              style={{ fontSize: 14, marginLeft: 6 }}
            >
              {" "}
              Drop Box{" "}
            </span>
          </div>
        </div>
        <span className="pt-3 d-flex justify-content-center align-items-start">
          <img src={DangerCircle} alt="" style={{ marginRight: 6 }} />
          <p
            className="th-auth-popup-media-txt1 mb-0"
            style={{ fontSize: 12, lineHeight: "16.5px" }}
          >
            <span className="mb-2">
              For accessibility purposes, who can view your post will be
            </span>{" "}
            {this.props.width > 992 && <br />}
            <span>able to download your document as a PDF.</span>
          </p>
        </span>
        {/*  */}
        <div className="d-flex justify-content-md-end justify-content-center th-auth-popup-btn-wraper">
          {this.props.width > 780 && (
            <div
              className="btn th-auth-popup-btn1 mx-2"
              onClick={this.props.closeModal}
            >
              Close
            </div>
          )}
          <div className="btn th-auth-popup-btn2" onClick={this.handlePublish}>
            Continue
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Document;
